export default __webpack_public_path__ + "static/media/21.56b450f6.jpeg";